import * as Yup from "yup";

export const shibbolethInitialValues = {
  email: "",
};

export const shibbolethEmailCheckSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

export const signInInitialValues = {
  email: "",
  password: "",
  rememberMe: true,
};

export const signInSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
  rememberMe: Yup.boolean(),
});
